import React, { useEffect, useState } from "react";
import { GetRefundPolicy } from "../../apiCall";
import { useQuery } from "react-query";
import { CACHE_TIME } from "../../Constants";
import { toast } from "react-toastify";

import "./refundPolicy.scss";
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [content, setContent] = useState();

  useQuery(["refund-policy"], () => GetRefundPolicy(), {
    // staleTime: STALE_TIME,
    cacheTime: CACHE_TIME,
    onSuccess: (data) => {
      // console.log(data);
      if (data.data?.status[0].Error === "False") {
        setContent(data.data.value);
      }
    },
    onError: (err) => {
      // console.log(err, "ERROR");
      if (err.message) {
        toast.error(err.message);
      } else {
        toast.error("Something went wrong");
      }
    },
  });
  return (
    <div className="refund-policy-main">
      
      {content && (
        <>
          <h1>Refund Policy</h1>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </>
      )}
    </div>
  );
};

export default RefundPolicy;
